import { Box, BoxProps, CircularProgress, CircularProgressProps } from "@mui/material";

export type CenteredLoaderProps = Omit<BoxProps, "children"> & {
  circularProgressProps?: CircularProgressProps;
};

const centeredSx = {
  width: "100%",
  minHeight: 240,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
} as const;

const CenteredLoader = ({ circularProgressProps, sx, ...boxProps }: CenteredLoaderProps) => (
  <Box
    sx={sx == null ? centeredSx : Array.isArray(sx) ? [centeredSx, ...sx] : [centeredSx, sx]}
    {...boxProps}
  >
    <CircularProgress color="primary" {...circularProgressProps} />
  </Box>
);

export default CenteredLoader;
